import Cookies from 'js-cookie';

const setCookie = (name, value, options) => {
  if (typeof window !== 'undefined') {
    Cookies.set(name, value, options);
  }
};

const getCookie = (name) => {
  if (typeof window !== 'undefined') {
    return Cookies.get(name);
  }
  return undefined;
};

const removeCookie = (name) => {
  if (typeof window !== 'undefined') {
    Cookies.remove(name);
  }
};

const cookieExists = (name) => {
  if (typeof window !== 'undefined') {
    const cookieValue = Cookies.get(name);
    return cookieValue !== undefined && cookieValue !== 'false';
  }
  return false;
};

export { setCookie, getCookie, removeCookie, cookieExists };
